import React, { useEffect, useRef, useState } from 'react';
import { Download } from 'lucide-react';
import { FONT, esc, aCapo, svgInPng } from '../../components/MappaProcesso';

// Immagine "Come ti iscrivi a un torneo FIPAV" (titolare 16/10 sera: legata al beach volley e a quello
// che fa il gestionale). Tre parti: la settimana del torneo con le zone (punti / coda / chiuso),
// i passi dell'atleta con il nome dei bottoni del portale, un esempio di classifica. Scadenze prese
// dalle regole in vigore. SVG disegnato dai dati: si adatta alla larghezza e si scarica in PNG.
const GG = ['DOM', 'LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB'];
const gg = (dow, prima) => GG[((dow - prima) % 7 + 7) % 7];
const C = { arancio: '#F4600C', punti: '#EA580C', coda: '#7C3AED', chiuso: '#DC2626', torneo: '#16A34A', testo: '#1D1D1F', grigio: '#6E6E73', sabbia: '#FBF3E4' };

const T = (x, y, testo, dim, peso = 400, colore = C.testo, extra = '') =>
  `<text x="${x}" y="${y}" font-size="${dim}" font-weight="${peso}" fill="${colore}" font-family="${FONT}" ${extra}>${esc(testo)}</text>`;
const righe = (r, x, y, dim, peso, colore, passo, extra = '') => r.map((t, i) => T(x, y + i * passo, t, dim, peso, colore, extra)).join('');
const pallone = (cx, cy, r) => `<g><circle cx="${cx}" cy="${cy}" r="${r}" fill="#fff" stroke="${C.testo}" stroke-width="2"/>`
  + `<path d="M ${cx - r * 0.95} ${cy - r * 0.3} Q ${cx} ${cy - r * 0.05} ${cx + r * 0.55} ${cy - r * 0.83}" fill="none" stroke="${C.testo}" stroke-width="1.8"/>`
  + `<path d="M ${cx - r * 0.2} ${cy + r * 0.98} Q ${cx - r * 0.1} ${cy} ${cx + r * 0.95} ${cy - r * 0.3}" fill="none" stroke="${C.testo}" stroke-width="1.8"/>`
  + `<path d="M ${cx - r * 0.75} ${cy + r * 0.65} Q ${cx + r * 0.1} ${cy + r * 0.35} ${cx + r * 0.75} ${cy + r * 0.65}" fill="none" stroke="${C.testo}" stroke-width="1.8"/></g>`;
const ora = (o) => o.replace(/^0/, '');

export function disegnaGuidaFipav(r, larghezza) {
  const W = Math.max(320, Math.round(larghezza));
  const P = W < 520 ? 14 : 24, stretta = W < 620;
  const pg = +r.priorita_giorni || 0, cg = +r.chiusura_giorni || 0;
  const out = [];
  let y = 0;

  // ── testata: sabbia, rete, pallone ──
  const hT = stretta ? 128 : 116;
  out.push(`<defs><linearGradient id="gt" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#F4600C"/><stop offset="1" stop-color="#FB923C"/></linearGradient></defs>`);
  out.push(`<rect x="0" y="0" width="${W}" height="${hT}" rx="18" fill="url(#gt)"/>`);
  const reteY = hT - 22;
  out.push(`<rect x="0" y="${reteY - 3}" width="${W}" height="3" fill="#fff" opacity=".9"/>`);
  for (let x = 8; x < W; x += 12) out.push(`<line x1="${x}" y1="${reteY}" x2="${x}" y2="${hT - 4}" stroke="#fff" stroke-opacity=".35"/>`);
  for (const yy of [reteY + 8, reteY + 16]) out.push(`<line x1="0" y1="${yy}" x2="${W}" y2="${yy}" stroke="#fff" stroke-opacity=".35"/>`);
  const rP = stretta ? 22 : 30;
  out.push(pallone(W - P - rP, stretta ? 34 : 44, rP));
  const tit = aCapo('Come ti iscrivi a un torneo FIPAV', W - 2 * P - rP * 2 - 10, stretta ? 21 : 26);
  out.push(righe(tit, P, stretta ? 34 : 44, stretta ? 21 : 26, 800, '#fff', stretta ? 25 : 30));
  out.push(T(P, (stretta ? 34 : 44) + tit.length * (stretta ? 25 : 30) - 4, 'Campionato Italiano per società · B-Cheers', stretta ? 12.5 : 14, 600, '#fff', 'opacity=".92"'));
  y = hT + 26;

  const sezione = (testo) => { const t = aCapo(testo, W - 2 * P, 17.5); out.push(righe(t, P, y, 13, 800, C.arancio, 17, 'letter-spacing="1.2"')); y += 14 + (t.length - 1) * 17; };

  // ── la settimana del torneo (sabato) ──
  sezione('LA SETTIMANA DEL TORNEO (ESEMPIO: TORNEO DI SABATO)');
  const giorni = ['PRIMA', ...Array.from({ length: pg + 1 }, (_, i) => gg(6, pg - i))];
  const cols = giorni.length, cw = (W - 2 * P) / cols;
  const frazione = (o) => { const [h, m] = o.split(':').map(Number); return (h * 60 + m) / 1440; };
  const xGiorno = (i) => P + cw * i;
  const xPrio = xGiorno(1) + cw * frazione(r.priorita_ora);
  const xChiu = xGiorno(1 + (pg - cg)) + cw * frazione(r.chiusura_ora);
  const xTorneo = xGiorno(cols - 1);
  y += 10;
  giorni.forEach((g, i) => out.push(T(xGiorno(i) + cw / 2, y + 12, g, 12, 700, i === cols - 1 ? C.torneo : C.grigio, 'text-anchor="middle"')));
  y += 22;
  const hB = 38;
  const barra = (x1, x2, col, testo) => {
    out.push(`<rect x="${x1}" y="${y}" width="${Math.max(0, x2 - x1)}" height="${hB}" fill="${col}"/>`);
    if (x2 - x1 > testo.length * 7.5 + 10) out.push(T((x1 + x2) / 2, y + 24, testo, 12.5, 800, '#fff', 'text-anchor="middle" letter-spacing=".6"'));
  };
  out.push(`<clipPath id="cb"><rect x="${P}" y="${y}" width="${W - 2 * P}" height="${hB}" rx="12"/></clipPath><g clip-path="url(#cb)">`);
  barra(P, xPrio, C.punti, 'CONTANO I PUNTI');
  barra(xPrio, xChiu, C.coda, 'CODA');
  barra(xChiu, xTorneo, C.chiuso, 'CHIUSO');
  barra(xTorneo, W - P, C.torneo, '');
  out.push('</g>');
  out.push(pallone(xTorneo + cw / 2, y + hB / 2, Math.min(14, cw / 3)));
  for (let i = 1; i < cols; i++) out.push(`<line x1="${xGiorno(i)}" y1="${y}" x2="${xGiorno(i)}" y2="${y + hB}" stroke="#fff" stroke-opacity=".35"/>`);
  y += hB;
  // bandierine con le ore
  const bandierina = (x, testo, col, livello) => {
    const yy = y + 8 + livello * 20;
    out.push(`<line x1="${x}" y1="${y - hB}" x2="${x}" y2="${yy + 6}" stroke="${col}" stroke-width="2"/>`);
    const w = testo.length * 7 + 14, left = Math.min(Math.max(P, x - w / 2), W - P - w);
    out.push(`<rect x="${left}" y="${yy + 4}" width="${w}" height="20" rx="10" fill="${col}"/>`);
    out.push(T(left + w / 2, yy + 18, testo, 12, 700, '#fff', 'text-anchor="middle"'));
  };
  bandierina(xPrio, `${gg(6, pg).toLowerCase()} ${ora(r.priorita_ora)}`, C.punti, 0);
  bandierina(xChiu, `${gg(6, cg).toLowerCase()} ${ora(r.chiusura_ora)}`, C.chiuso, Math.abs(xChiu - xPrio) < 110 ? 1 : 0);
  y += Math.abs(xChiu - xPrio) < 110 ? 54 : 34;
  // legenda
  const leggenda = [
    [C.punti, `Fino a ${gg(6, pg).toLowerCase()} ${ora(r.priorita_ora)}: la classifica è per punti della coppia (a parità, chi si è iscritto prima).`],
    [C.coda, `Dopo: si entra in coda in ordine di iscrizione, i punti non contano.`],
    [C.chiuso, `Da ${gg(6, cg).toLowerCase()} ${ora(r.chiusura_ora)} non ci si iscrive più: la società fa le iscrizioni sul portale FIPAV (BVL).`],
  ];
  const colL = stretta ? 1 : 3, lw = (W - 2 * P - (colL - 1) * 14) / colL;
  let hL = 0;
  leggenda.forEach(([col, testo], i) => {
    const x = P + (i % colL) * (lw + 14), yy = y + Math.floor(i / colL) * 0 + (stretta ? hL : 0);
    const t = aCapo(testo, lw - 18, 13);
    out.push(`<circle cx="${x + 5}" cy="${yy + 9}" r="5" fill="${col}"/>`);
    out.push(righe(t, x + 16, yy + 13, 13, 500, C.testo, 17.5));
    if (stretta) hL += t.length * 17.5 + 8; else hL = Math.max(hL, t.length * 17.5 + 8);
  });
  y += hL + 4;
  const dom = aCapo(`Torneo di domenica? Tutto un giorno dopo: ${gg(0, pg).toLowerCase()} ${ora(r.priorita_ora)} e ${gg(0, cg).toLowerCase()} ${ora(r.chiusura_ora)}.`, W - 2 * P, 12.5);
  out.push(righe(dom, P, y + 12, 12.5, 600, C.grigio, 17));
  y += 40 + (dom.length - 1) * 17;

  // ── cosa fai tu ──
  sezione('COSA FAI TU, PASSO PER PASSO');
  y += 8;
  const passi = [
    ['Entra nel portale', 'Menu FIPAV, poi Calendario. Serve la tessera FIPAV della stagione con B-Cheers.', 'FIPAV › Calendario'],
    ['Scegli il torneo', 'Campionato per società: passa dalla società. Ogni torneo ti dice se hai i punti o l\'età giusti, e le scadenze.', 'Solo dove posso giocare'],
    ['Iscrivi la coppia', 'Cerca il compagno tra gli atleti B-Cheers. Chi iscrive diventa il capitano: vale per tutta la coppia.', 'Chiedi di partecipare'],
    ['Guarda la classifica', 'Si aggiorna da sola a ogni iscrizione: posizione, punti, nei posti della società o lista d\'attesa.', 'Iscrizioni atleti B-Cheers'],
    ['Giochi!', 'Dopo la chiusura la società ti iscrive sul portale BVL; se entri in tabellone o sei riserva lo decide la lista FIPAV e lo vedi qui. Se ti sposta ricevi una mail. La quota si paga alla tappa.', 'Le mie iscrizioni'],
  ];
  const colP = W >= 980 ? 5 : W >= 620 ? 3 : 1, G = 12;
  const pw = (W - 2 * P - (colP - 1) * G) / colP;
  for (let i = 0; i < passi.length; i += colP) {
    const gruppo = passi.slice(i, i + colP);
    const mis = gruppo.map(([t, d]) => ({ t: aCapo(t, pw - 70, 15.5), d: aCapo(d, pw - 28, 13) }));
    const h = Math.max(...mis.map(m => 58 + Math.max(0, m.t.length - 1) * 19 + m.d.length * 17.5 + 44));
    gruppo.forEach(([, , bottone], j) => {
      const x = P + j * (pw + G), m = mis[j], n = i + j + 1;
      out.push(`<rect x="${x}" y="${y}" width="${pw}" height="${h}" rx="16" fill="#fff" stroke="#E5E5EA"/>`);
      out.push(`<circle cx="${x + 30}" cy="${y + 30}" r="17" fill="${n === 5 ? C.torneo : C.arancio}"/>`);
      out.push(T(x + 30, y + 36, String(n), 17, 800, '#fff', 'text-anchor="middle"'));
      out.push(righe(m.t, x + 56, y + 35, 15.5, 800, C.testo, 19));
      const yd = y + 58 + Math.max(0, m.t.length - 1) * 19 + 6;
      out.push(righe(m.d, x + 14, yd, 13, 400, '#3A3A3C', 17.5));
      const bw = Math.min(pw - 28, bottone.length * 7.2 + 24);
      out.push(`<rect x="${x + 14}" y="${y + h - 38}" width="${bw}" height="26" rx="13" fill="${C.testo}"/>`);
      out.push(T(x + 14 + bw / 2, y + h - 20.5, bottone, 12, 700, '#fff', 'text-anchor="middle"'));
    });
    y += h + G;
  }
  y += 22;

  // ── il capitano e un torneo per giornata (titolare 16/10 sera) ──
  sezione('IL CAPITANO E LA REGOLA DELLA GIORNATA');
  y += 8;
  const affiancati = W >= 760, GQ = 14;
  const qw = affiancati ? (W - 2 * P - GQ) / 2 : W - 2 * P;
  const fascia = (x, yy, n, col) => {
    out.push(`<circle cx="${x + 30}" cy="${yy + 30}" r="17" fill="${col}"/>`);
    out.push(T(x + 30, yy + 36, n, 16, 800, '#fff', 'text-anchor="middle"'));
  };
  // riquadro 1: capitano
  const t1 = aCapo('Chi iscrive è il capitano', qw - 70, 15.5);
  const d1 = aCapo('Solo lui, da FIPAV › Le mie iscrizioni, può:', qw - 28, 13);
  const bott = [['Sposta in un altro torneo', C.testo], ['Cambia compagno', C.testo], ['Annulla iscrizione', C.chiuso]];
  const n1 = aCapo("Fino alla chiusura e finché la società non vi iscrive su BVL (dopo scrivi allo staff). Spostarsi o cambiare compagno conta come iscrizione nuova: vale l'ora del cambio. Il compagno vede tutto e chiede al capitano.", qw - 28, 12.5);
  const h1 = 58 + (t1.length - 1) * 19 + d1.length * 17.5 + 8 + bott.length * 32 + 6 + n1.length * 17 + 14;
  // riquadro 2: un torneo per giornata
  const t2 = aCapo('Un solo torneo per giornata', qw - 70, 15.5);
  const tornei = [['SAB · Beginner · Milano', true], ['SAB · Bronze · Bergamo', false]];
  const n2 = aCapo('Non puoi essere iscritto a due tornei nello stesso giorno, neanche in città diverse. Vale per tutti e due gli atleti e per tutti i tornei, anche la Serie Beach.', qw - 28, 12.5);
  const h2 = 58 + (t2.length - 1) * 19 + tornei.length * 42 + 6 + n2.length * 17 + 14;
  const hq = affiancati ? Math.max(h1, h2) : 0;
  const disegna1 = (x, yy, h) => {
    out.push(`<rect x="${x}" y="${yy}" width="${qw}" height="${h}" rx="16" fill="#fff" stroke="#E5E5EA"/>`);
    fascia(x, yy, 'C', C.arancio);
    out.push(righe(t1, x + 56, yy + 35, 15.5, 800, C.testo, 19));
    let z = yy + 58 + (t1.length - 1) * 19 + 6;
    out.push(righe(d1, x + 14, z, 13, 400, '#3A3A3C', 17.5)); z += d1.length * 17.5 - 4;
    bott.forEach(([b, col]) => {
      const bw = Math.min(qw - 28, b.length * 7.2 + 24);
      out.push(`<rect x="${x + 14}" y="${z}" width="${bw}" height="26" rx="13" fill="${col}"/>`);
      out.push(T(x + 14 + bw / 2, z + 17.5, b, 12, 700, '#fff', 'text-anchor="middle"'));
      z += 32;
    });
    out.push(righe(n1, x + 14, z + 14, 12.5, 500, C.grigio, 17));
  };
  const disegna2 = (x, yy, h) => {
    out.push(`<rect x="${x}" y="${yy}" width="${qw}" height="${h}" rx="16" fill="#fff" stroke="#E5E5EA"/>`);
    fascia(x, yy, '1', C.torneo);
    out.push(righe(t2, x + 56, yy + 35, 15.5, 800, C.testo, 19));
    let z = yy + 58 + (t2.length - 1) * 19 - 4;
    tornei.forEach(([nome, ok]) => {
      const tw = qw - 28;
      out.push(`<rect x="${x + 14}" y="${z}" width="${tw}" height="34" rx="10" fill="${ok ? '#F0FDF4' : '#FEF2F2'}" stroke="${ok ? '#86EFAC' : '#FCA5A5'}"/>`);
      out.push(T(x + 26, z + 22, nome, 13, 700, ok ? C.testo : '#991B1B', ok ? '' : 'text-decoration="line-through"'));
      out.push(`<circle cx="${x + 14 + tw - 20}" cy="${z + 17}" r="10" fill="${ok ? C.torneo : C.chiuso}"/>`);
      out.push(ok
        ? `<path d="M ${x + tw - 11} ${z + 17} l 3.5 3.5 l 6 -7" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>`
        : `<path d="M ${x + tw - 10} ${z + 13} l 8 8 M ${x + tw - 2} ${z + 13} l -8 8" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>`);
      z += 42;
    });
    out.push(righe(n2, x + 14, z + 12, 12.5, 500, C.grigio, 17));
  };
  if (affiancati) { disegna1(P, y, hq); disegna2(P + qw + GQ, y, hq); y += hq + 22; }
  else { disegna1(P, y, h1); y += h1 + GQ; disegna2(P, y, h2); y += h2 + 22; }

  // ── come si forma la classifica ──
  sezione('COME SI FORMA LA CLASSIFICA (ESEMPIO)');
  y += 8;
  const posti = r.max_coppie || 4;
  const lista = [
    ['Coppia A', '438 pt', 'punti', 'iscritta giovedì'],
    ['Coppia B', '312 pt', 'punti', 'iscritta sabato'],
    ['Coppia C', '312 pt', 'punti', 'iscritta domenica: pari punti, dopo B'],
    ['Coppia D', '90 pt', 'punti', 'iscritta lunedì mattina'],
    ['Coppia E', '510 pt', 'coda', 'iscritta martedì: in coda, i punti non contano'],
    ['Coppia F', '200 pt', 'coda', 'iscritta mercoledì 8:40'],
  ];
  const rw = Math.min(W - 2 * P, 760), hr = stretta ? 50 : 40;
  lista.forEach(([nome, pt, fascia, nota], i) => {
    if (i === 4) {
      out.push(`<line x1="${P}" y1="${y + 6}" x2="${P + rw}" y2="${y + 6}" stroke="${C.coda}" stroke-width="2" stroke-dasharray="6 5"/>`);
      out.push(T(P + rw, y + 20, `↓ dopo la scadenza con priorità`, 11.5, 700, C.coda, 'text-anchor="end"'));
      y += 26;
    }
    if (i === posti) {
      out.push(`<line x1="${P}" y1="${y + 6}" x2="${P + rw}" y2="${y + 6}" stroke="${C.chiuso}" stroke-width="2.5"/>`);
      out.push(T(P + rw, y + 20, `↑ ${posti} posti della società · ↓ lista d'attesa`, 11.5, 800, C.chiuso, 'text-anchor="end"'));
      y += 26;
    }
    const col = fascia === 'punti' ? C.punti : C.coda;
    const ammessa = i < posti;
    out.push(`<rect x="${P}" y="${y}" width="${rw}" height="${hr}" rx="12" fill="#fff" stroke="#E5E5EA" ${ammessa ? '' : 'opacity=".75"'}/>`);
    out.push(`<rect x="${P}" y="${y}" width="5" height="${hr}" rx="2.5" fill="${col}"/>`);
    out.push(`<circle cx="${P + 26}" cy="${y + hr / 2}" r="13" fill="${C.sabbia}" stroke="#E8D9BD"/>`);
    out.push(T(P + 26, y + hr / 2 + 5, String(i + 1), 13, 800, C.testo, 'text-anchor="middle"'));
    out.push(T(P + 48, y + (stretta ? 20 : hr / 2 + 5), `${nome} · ${pt}`, 14, 700, C.testo));
    out.push(T(stretta ? P + 48 : P + 190, stretta ? y + 38 : y + hr / 2 + 5, nota, 12.5, 400, C.grigio));
    const tag = ammessa ? 'nei posti della società' : "lista d'attesa", tw = tag.length * 7 + 16;
    if (!stretta) {
      out.push(`<rect x="${P + rw - tw - 10}" y="${y + hr / 2 - 11}" width="${tw}" height="22" rx="11" fill="${ammessa ? '#DCFCE7' : '#FEF3C7'}"/>`);
      out.push(T(P + rw - 10 - tw / 2, y + hr / 2 + 4, tag, 12, 700, ammessa ? '#15803D' : '#B45309', 'text-anchor="middle"'));
    }
    y += hr + 6;
  });
  y += 4;
  const fine = aCapo('La classifica è in tempo reale: si aggiorna da sola a ogni iscrizione o cambio di punti FIPAV. La vedi in FIPAV › Iscrizioni atleti B-Cheers; la tua posizione anche in Le mie iscrizioni.', W - 2 * P, 13);
  out.push(righe(fine, P, y + 14, 13, 600, C.testo, 18));
  y += fine.length * 18 + 22;

  // ── serie beach ──
  const nota = aCapo("Serie Beach (B1, B2…) e altri tornei: ti iscrivi da solo sul portale FIPAV, anche con un atleta di un'altra società, e qui premi «Segnala con chi giochi». Nessuna classifica e nessuna conferma della società.", W - 2 * P - 28, 13);
  const hN = 22 + nota.length * 17.5;
  out.push(`<rect x="${P}" y="${y}" width="${W - 2 * P}" height="${hN}" rx="14" fill="#EFF6FF" stroke="#93C5FD" stroke-dasharray="5 4"/>`);
  out.push(righe(nota, P + 14, y + 25, 13, 500, '#1E3A8A', 17.5));
  y += hN + P;

  const H = Math.round(y);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}"><rect width="${W}" height="${H}" rx="18" fill="${C.sabbia}"/>${out.join('')}</svg>`;
  return { svg, w: W, h: H };
}

export default function GuidaIscrizioneFipav({ regole }) {
  const box = useRef(null);
  const [larghezza, setLarghezza] = useState(0);
  useEffect(() => {
    if (!box.current) return;
    const ro = new ResizeObserver(([e]) => setLarghezza(Math.floor(e.contentRect.width)));
    ro.observe(box.current);
    return () => ro.disconnect();
  }, []);
  const { svg } = larghezza ? disegnaGuidaFipav(regole, Math.min(larghezza, 1100)) : { svg: '' };
  return (
    <div>
      <div ref={box} style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: svg }} />
      <button onClick={() => svgInPng(disegnaGuidaFipav(regole, 1100), 'iscrizioni-fipav-b-cheers.png')} style={{ marginTop: '10px', display: 'inline-flex', alignItems: 'center', gap: '6px', border: '1px solid var(--border2)', background: 'var(--bg-card)', color: 'var(--text)', borderRadius: '999px', padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>
        <Download size={14} /> Scarica come immagine (PNG)
      </button>
    </div>
  );
}
